import React from 'react';

const PrintHeaderProcesVerbal = ({ etablissement, procesVerbal }) => {
  return (
    <div className="hidden print:block print:mb-2">
      {/* En-tête administratif ultra-compact */}
      <div className="border-b-2 border-black pb-1 mb-2">
        {/* Ligne 1: République et Année */}
        <div className="flex justify-between items-center mb-0">
          <div className="w-[25%]">
            {(etablissement?.logo || etablissement?.logo_url) && (
              <img 
                src={etablissement.logo || etablissement.logo_url} 
                alt="Logo" 
                className="object-contain h-12 w-12"
              />
            )}
          </div>
          <div className="w-[50%] text-center">
            <p className="text-xs font-bold uppercase mb-0">
              RÉPUBLIQUE {etablissement?.pays ? `DU ${etablissement.pays.toUpperCase()}` : 'DU NIGER'}
            </p>
            <div className="w-16 h-px bg-black mx-auto"></div>
            <p className="text-xs uppercase mb-0">
              MINISTÈRE DE {etablissement?.ministere?.toUpperCase() || 'L\'EDUCATION NATIONALE'}
            </p>
          </div>
          <div className="w-[25%] text-right">
            <div className="inline-block border border-black px-2 py-1 text-xs">
              <div className="text-center">
                <div className="text-xs font-bold">Année Académique</div>
                <div className="text-xs font-bold">
                  {procesVerbal?.soutenance?.annee_academique?.libelle || '2025-2026'}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Ligne 2: Établissement */}
        <div className="text-center mb-0">
          <h1 className="text-base font-bold mb-0">
            {etablissement?.libelle || etablissement?.nom || 'Ecole Superieure des telecommunications'}
          </h1>
          <p className="text-xs italic mb-0">
            {etablissement?.devise || 'Travail-Progrès-Réussite'}
          </p>
        </div>
        
        {/* Ligne 3: Coordonnées sur une seule ligne */}
        <div className="text-center text-xs mb-0">
          Email: {etablissement?.email || 'est@gmail.com'} | 
          Contact: {etablissement?.contact || etablissement?.telephone || '99956432'} | 
          BP: {etablissement?.bp || '8000'} | 
          Site: {etablissement?.site_web || etablissement?.website || 'https://console.twilio.com'}
          <br />
          {etablissement?.adresse || 'Niamey/Rue des Ecoles'}
        </div>
      </div>
      
      {/* Titre du document - très compact */}
      <div className="text-center mb-2">
        <div className="inline-block border-2 border-black px-4 py-1">
          <h2 className="text-base font-bold tracking-wide mb-0">PROCÈS-VERBAL DE SOUTENANCE</h2>
        </div>
        <h3 className="text-sm font-semibold mt-1 mb-0">
          {procesVerbal?.soutenance?.type_soutenance?.libelle || 'Soutenance de Mémoire'}
        </h3>
      </div>
    </div>
  );
};

export default PrintHeaderProcesVerbal; 